import { jsxs as $, jsx as a } from "react/jsx-runtime";
import g from "clsx";
import { forwardRef as x } from "react";
const y = (r) => g(r), l = "dds-select-v0142", M = x(
  ({
    ariaDescribedby: r,
    ariaLabel: s,
    ariaLabelledby: d,
    autocomplete: p,
    className: i = "",
    defaultValue: o,
    disabled: t = !1,
    id: u,
    inputProps: b,
    invalid: c = !1,
    name: m,
    options: f,
    ...v
  }, h) => {
    function n(e) {
      return typeof e == "string" ? /* @__PURE__ */ a("option", { value: e, children: e }, e) : "value" in e ? /* @__PURE__ */ a("option", { value: e.value, disabled: e.disabled, "aria-label": e.ariaLabel, children: e.label || e.value }, e.value) : /* @__PURE__ */ a("optgroup", { label: e.label, children: e.options.map((L) => n(L)) }, e.label);
    }
    const _ = {
      [`${l}`]: !0,
      [`${l}--disabled`]: t,
      [`${l}--invalid`]: c,
      [i]: i.length > 0
    };
    return /* @__PURE__ */ $("div", { className: y(_), ...v, children: [
      /* @__PURE__ */ a(
        "select",
        {
          "aria-describedby": r,
          "aria-invalid": c ? "true" : "false",
          "aria-label": s,
          "aria-labelledby": d,
          autoComplete: p,
          className: `${l}__select`,
          defaultValue: o,
          disabled: t,
          id: u,
          name: m,
          ref: h,
          ...b,
          children: f.map((e) => n(e))
        }
      ),
      /* @__PURE__ */ a("div", { className: `${l}__container`, children: /* @__PURE__ */ a("svg", { className: `${l}__glyph`, viewBox: "0 0 8 8", children: /* @__PURE__ */ a("path", { d: "M6.191,2.402c0.185-0.185,0.485-0.185,0.67,0c0.185,0.185,0.185,0.485,0,0.67L4.335,5.598c-0.185,0.184-0.485,0.184-0.67,0L1.139,3.072c-0.185-0.185-0.185-0.485,0-0.67c0.185-0.185,0.485-0.185,0.67,0L4,4.593L6.191,2.402z" }) }) })
    ] });
  }
);
export {
  M as Select
};
//# sourceMappingURL=index.js.map
